// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    DiscussionsSearchRequestData,
    DiscussionsSearchRequestDataFromJSON,
    DiscussionsSearchRequestDataToJSON,
    DiscussionsSearchResults,
    DiscussionsSearchResultsFromJSON,
    DiscussionsSearchResultsToJSON,
    OrgSearchRequest,
    OrgSearchRequestFromJSON,
    OrgSearchRequestToJSON,
    OrgSearchResults,
    OrgSearchResultsFromJSON,
    OrgSearchResultsToJSON,
    PeopleSearchRequestData,
    PeopleSearchRequestDataFromJSON,
    PeopleSearchRequestDataToJSON,
    PeopleSearchResults,
    PeopleSearchResultsFromJSON,
    PeopleSearchResultsToJSON,
    SearchRequest,
    SearchRequestFromJSON,
    SearchRequestToJSON,
    SearchResults,
    SearchResultsFromJSON,
    SearchResultsToJSON,
} from '../models';

export interface DiscussionsSearchRequest {
    data: DiscussionsSearchRequestData;
}

export interface LibrarySearchRequest {
    data: SearchRequest;
}

export interface OrganizationSearchRequest {
    data: OrgSearchRequest;
}

export interface PeopleSearchRequest {
    data: PeopleSearchRequestData;
}

/**
 * no description
 */
export class SearchApi extends runtime.BaseAPI {

    /**
     * Search for threads.
     */
    async discussionsSearchRaw(requestParameters: DiscussionsSearchRequest): Promise<runtime.ApiResponse<DiscussionsSearchResults>> {
        if (requestParameters.data === null || requestParameters.data === undefined) {
            throw new runtime.RequiredError('data','Required parameter requestParameters.data was null or undefined when calling discussionsSearch.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("LabXChange API", ["read", "write"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/search/discussions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DiscussionsSearchRequestDataToJSON(requestParameters.data),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DiscussionsSearchResultsFromJSON(jsonValue));
    }

    /**
     * Search for threads.
     */
    async discussionsSearch(requestParameters: DiscussionsSearchRequest): Promise<DiscussionsSearchResults> {
        const response = await this.discussionsSearchRaw(requestParameters);
        return await response.value();
    }

    /**
     * This should really be a GET method since it does not mutate anything, but we want to accept body parameters so it's a POST method.
     * Search for items in the library.
     */
    async librarySearchRaw(requestParameters: LibrarySearchRequest): Promise<runtime.ApiResponse<SearchResults>> {
        if (requestParameters.data === null || requestParameters.data === undefined) {
            throw new runtime.RequiredError('data','Required parameter requestParameters.data was null or undefined when calling librarySearch.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("LabXChange API", ["read", "write"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/search/library`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchRequestToJSON(requestParameters.data),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchResultsFromJSON(jsonValue));
    }

    /**
     * This should really be a GET method since it does not mutate anything, but we want to accept body parameters so it's a POST method.
     * Search for items in the library.
     */
    async librarySearch(requestParameters: LibrarySearchRequest): Promise<SearchResults> {
        const response = await this.librarySearchRaw(requestParameters);
        return await response.value();
    }

    /**
     * This should really be a GET method since it does not mutate anything, but we want to accept body parameters so it's a POST method.
     * Search for organizations
     */
    async organizationSearchRaw(requestParameters: OrganizationSearchRequest): Promise<runtime.ApiResponse<OrgSearchResults>> {
        if (requestParameters.data === null || requestParameters.data === undefined) {
            throw new runtime.RequiredError('data','Required parameter requestParameters.data was null or undefined when calling organizationSearch.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("LabXChange API", ["read", "write"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/search/organizations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrgSearchRequestToJSON(requestParameters.data),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OrgSearchResultsFromJSON(jsonValue));
    }

    /**
     * This should really be a GET method since it does not mutate anything, but we want to accept body parameters so it's a POST method.
     * Search for organizations
     */
    async organizationSearch(requestParameters: OrganizationSearchRequest): Promise<OrgSearchResults> {
        const response = await this.organizationSearchRaw(requestParameters);
        return await response.value();
    }

    /**
     * This should really be a GET method since it does not mutate anything, but we want to accept body parameters so it's a POST method.
     * Search for user profiles
     */
    async peopleSearchRaw(requestParameters: PeopleSearchRequest): Promise<runtime.ApiResponse<PeopleSearchResults>> {
        if (requestParameters.data === null || requestParameters.data === undefined) {
            throw new runtime.RequiredError('data','Required parameter requestParameters.data was null or undefined when calling peopleSearch.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("LabXChange API", ["read", "write"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/search/profiles`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PeopleSearchRequestDataToJSON(requestParameters.data),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PeopleSearchResultsFromJSON(jsonValue));
    }

    /**
     * This should really be a GET method since it does not mutate anything, but we want to accept body parameters so it's a POST method.
     * Search for user profiles
     */
    async peopleSearch(requestParameters: PeopleSearchRequest): Promise<PeopleSearchResults> {
        const response = await this.peopleSearchRaw(requestParameters);
        return await response.value();
    }

}
